import React, { useEffect, useState } from 'react';
import { productsAPI } from '../utils/api';
import ProductCard from '../components/ProductCard';
import SEO, { SITE_URL } from '../components/SEO';

const BestSeller = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const { data } = await productsAPI.getAll({ is_bestseller: true });
      setProducts(data);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="bestseller-page">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-cormorant text-4xl sm:text-5xl lg:text-6xl leading-none mb-8" data-testid="bestseller-heading">Best Sellers</h1>
        <SEO title="Best Sellers - Most Loved Ethnic Wear" description="Shop our most loved pieces at Studio Crochet. Best selling sarees, lehengas, and ethnic wear. COD available." canonical={`${SITE_URL}/bestseller`} />
        <p className="font-outfit text-lg text-[#8C8577] mb-12">Our most loved pieces</p>
        
        {loading ? (
          <div className="text-center py-20" data-testid="loading-indicator">
            <p className="font-outfit text-[#8C8577]">Loading...</p>
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-12" data-testid="products-grid">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20" data-testid="no-products">
            <p className="font-outfit text-[#8C8577]">No bestsellers available yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BestSeller;